import { render, staticRenderFns } from "./dashboard-widget.vue?vue&type=template&id=a7606204&"
import script from "./dashboard-widget.component.ts?vue&type=script&lang=ts&"
export * from "./dashboard-widget.component.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard-widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7606204')) {
      api.createRecord('a7606204', component.options)
    } else {
      api.reload('a7606204', component.options)
    }
    module.hot.accept("./dashboard-widget.vue?vue&type=template&id=a7606204&", function () {
      api.rerender('a7606204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/dashboard/components/dashboard-widget.vue"
export default component.exports